export default "__VITE_ASSET__GzR4vqNH__"